import Swal from "sweetalert2";
import Toastify from "toastify-js";
import { TemplateEngine } from "../utils/TemplateEngine.js";

// Helpers de interfaz. Equivalen a los de common.js de la app anterior, con dos
// arreglos: los mensajes de error muestran texto legible en vez de
// "[object Object]", y el resultado trae un botón para copiar el código.

const asegurarDialogo = () => {
  let dlg = document.getElementById("loadingDialog");
  if (!dlg) {
    dlg = document.createElement("dialog");
    dlg.id = "loadingDialog";
    dlg.innerHTML = '<div class="loading-spinner"></div><p>Cargando...</p>';
    document.body.appendChild(dlg);
  }
  return dlg;
};

export const Loading = (show = true) => {
  const dlg = asegurarDialogo();
  if (show) {
    if (!dlg.open) dlg.showModal();
  } else if (dlg.open) {
    dlg.close();
  }
};

/** Acepta string, Error o cualquier cosa: siempre muestra algo legible. */
const textoDe = (mensaje) => {
  if (typeof mensaje === "string") return mensaje;
  if (mensaje instanceof Error) return mensaje.message;
  if (mensaje && typeof mensaje === "object") return mensaje.message || JSON.stringify(mensaje);
  return String(mensaje ?? "");
};

export const showMessage = (mensaje, type = "success", duration = 3000) => {
  Loading(false);
  Toastify({
    text: textoDe(mensaje),
    duration,
    close: true,
    gravity: "bottom",
    position: "right",
    stopOnFocus: true,
    style: { background: type === "success" ? "green" : "red" },
  }).showToast();
};

export const showDialog = async (titulo, mensaje, type = "ok") => {
  Loading(false);
  if (type === "confirm") {
    const result = await Swal.fire({
      title: titulo,
      html: mensaje,
      showCancelButton: true,
      confirmButtonText: "Sí",
      cancelButtonText: "Cancelar",
    });
    return result.isConfirmed;
  }

  await Swal.fire({
    title: titulo,
    html: mensaje,
    icon: type === "ok" ? "success" : "error",
  });
  return true;
};

/**
 * Resultado de un cálculo: el código, el botón de copiar y el link para
 * compartirlo por WhatsApp.
 */
export const mostrarResultado = async ({ titulo, codigo, aviso = "" }) => {
  Loading(false);

  const codigoSeguro = TemplateEngine.escapeHtml(codigo);
  const tituloSeguro = TemplateEngine.escapeHtml(titulo);
  const textoWhatsapp = encodeURIComponent(`Este es el código de ${titulo} que solicitaste: ${codigo}`);

  const html = `
    <p class="mb-1">El código de ${tituloSeguro} es:</p>
    <p class="codigo-resultado" id="codigoGenerado">${codigoSeguro}</p>
    <button type="button" class="btn btn-outline-secondary btn-sm mb-3" id="btnCopiarCodigo">
      <i class="fas fa-copy me-1"></i>Copiar código
    </button>
    <p class="mb-0">
      <a href="https://api.whatsapp.com/send?text=${textoWhatsapp}" target="_blank" rel="noopener"
         title="Compartir por WhatsApp">
        <i class="fa-brands fa-whatsapp"></i> Compartilo haciendo click acá
      </a>
    </p>
    ${aviso ? `<p class="text-warning small mt-3 mb-0">${TemplateEngine.escapeHtml(aviso)}</p>` : ""}
  `;

  await Swal.fire({
    title: "Resultado",
    html,
    icon: "success",
    didOpen: () => {
      document.getElementById("btnCopiarCodigo")?.addEventListener("click", async (e) => {
        const boton = e.currentTarget;
        try {
          await navigator.clipboard.writeText(String(codigo));
          boton.innerHTML = '<i class="fas fa-check me-1"></i>Copiado';
        } catch {
          // Sin permiso de portapapeles (o sin HTTPS) se selecciona el texto
          // para que el usuario copie a mano.
          const rango = document.createRange();
          rango.selectNodeContents(document.getElementById("codigoGenerado"));
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(rango);
          boton.innerHTML = '<i class="fas fa-i-cursor me-1"></i>Copialo con Ctrl+C';
        }
      });
    },
  });
};
